import { observable, computed, runInAction } from 'mobx';
import { Video } from './';
import { hyphenate } from '../utils/string';

export class Category {
  @observable public id: number;
  @observable public name: string;
  @observable public children?: Array<Category>;
  @observable public parent?: Category;
  @observable public image: string = '';
  @observable public description?: string;
  @observable public videos?: Array<Video>;

  constructor(
    id: number,
    name: string,
    children?: Array<Category>,
    parent?: Category,
    image: string = '',
    description?: string,
    videos?: Array<Video>
  ) {
    runInAction(() => {
      this.id = id;
      this.name = name;
      this.children = children;
      this.parent = parent;
      this.image = image;
      this.description = description;
      this.videos = videos;

      if (this.children) {
        this.children.forEach(child => (child.parent = this));
      }

      if (this.videos) {
        this.videos.forEach(video => (video.category = this));
      }
    });
  }

  @computed
  public get route(): string {
    const route = this.relativeRoute;

    return this.parent
      ? `${this.parent.route}/${route}`
      : // Prefix "root routes" with `/categories/`
        `/categories/${route}`;
  }

  @computed
  public get relativeRoute(): string {
    return hyphenate(`${this.name}-${this.id}`);
  }
}

export default Category;



// WEBPACK FOOTER //
// ./src/app/models/Category.ts